
import React, { Component } from "react";
import Lottie from "lottie-react";
import animationJson from "./plane.json";

export interface PlaneAnimationProps
{
}

interface PlaneAnimationState 
{
}

export class PlaneAnimation extends Component<PlaneAnimationProps, PlaneAnimationState>
{
    constructor(props: PlaneAnimationProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <Lottie animationData={animationJson} loop={true} />
        );
    }
}